/* eslint-disable camelcase */
// node modules
import React from 'react';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

// app modules: components
import Price from 'components/Price';

const GET_PRICE = gql`
  query GetPrice($provider: String!, $productId: String!, $country: String, $coupon: String) {
    Price(provider: $provider, productId: $productId, country: $country, coupon: $coupon) {
      coupon
      currency
      list_price
      offer_price
      period
      interval
      trial_days
    }
  }
`;

function DefaultOfferPrice(props) {
  const {
    condensed,
    provider,
    productId,
    className,
    prefix,
    hidePriceForTrial,
    hideUnlessDiscounted,
  } = props;
  const requestedCoupon = useSelector(state => state.paywall.requestedCoupon);
  const country = useSelector(state => state.paywall.country || state.user.geolocation.countryCode);
  const language = useSelector(state => state.config.language);
  const defaultProductId = useSelector(
    state => state.paywall.productId || state.config.paywall.products.monthly.paddleProductId,
  );
  const { loading, error, data } = useQuery(GET_PRICE, {
    variables: {
      country,
      coupon: requestedCoupon,
      productId: String(productId || defaultProductId),
      provider,
    },
  });

  if (loading)
    return (
      <div className={className}>
        <p />
      </div>
    );
  if (error) return `Error! ${error}`;
  const { coupon, currency, list_price, offer_price, period, interval, trial_days } = data.Price;
  const recurrence = `${interval > 1 ? `${interval} ` : ''}${period}`;
  const hasDiscount = parseFloat(offer_price) < parseFloat(list_price);
  if (hidePriceForTrial && trial_days > 0) {
    return (
      <div className={className}>
        <p>Start your free trial today</p>
      </div>
    );
  }
  if (coupon && hasDiscount) {
    return (
      <div className={className}>
        <p>
          <b>{coupon.toUpperCase()} DISCOUNT</b> {!condensed && 'Just'}{' '}
          <b>
            <Price
              currency={currency}
              amount={offer_price}
              originalPrice={list_price}
              language={language}
            />
          </b>/{recurrence}
        </p>
      </div>
    );
  }
  if (!hideUnlessDiscounted) {
    return (
      <div className={className}>
        <p>
          {prefix}
          <b>
            <Price currency={currency} amount={offer_price} language={language} />
          </b>/{recurrence}
        </p>
      </div>
    );
  }
  return null;
}

DefaultOfferPrice.propTypes = {
  className: PropTypes.string,
  condensed: PropTypes.bool,
  hidePriceForTrial: PropTypes.bool,
  hideUnlessDiscounted: PropTypes.bool,
  prefix: PropTypes.node,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  provider: PropTypes.string,
};

DefaultOfferPrice.defaultProps = {
  className: null,
  condensed: false,
  hidePriceForTrial: false,
  hideUnlessDiscounted: false,
  prefix: <React.Fragment>Join today for </React.Fragment>,
  productId: null,
  provider: 'paddle',
};

export default DefaultOfferPrice;
